import {
  BookingStatus,
  BookingTransactionType, BookingTransactionTypeLabel,
} from "../../../../constants/securspace-constants";
import {PaymentProcessor, SupplierInvoiceStatusGroup} from "../../../../constants/booking-transaction-constants";

const sortByOptions: {label: string, value: string}[] = [
  {label: 'Invoice Number', value: 'TRANSACTION_NUMBER'},
  {label: 'Start Date', value: 'SERVICE_START_DATE'},
  {label: 'End Date', value: 'SERVICE_END_DATE'},
  {label: 'Booking Number', value: 'BOOKING_NUMBER'},
  {label: 'Equipment Type', value: 'ASSET_TYPE'},
  {label: 'Buyer', value: 'BUYER_COMPANY_NAME'},
  {label: 'Supplier', value: 'SUPPLIER_COMPANY_NAME'},
  {label: 'Booking Charge Type', value: 'TYPE'},
  {label: 'Booking Status', value: 'BOOKING_STATUS'},
  {label: 'Transaction Status', value: 'STATUS'},
  {label: 'Tax Status', value: 'TAX_STATUS'},
  {label: 'Payment Processor', value: 'PAYMENT_PROCESSOR'},
];

const filterByOptions: {name: string, label: string, value: string, numberField?: boolean, inputProps?: {inputMode: string}}[] = [
  {name: 'bookingNumber', label: 'Booking Number', value: '', numberField: true, inputProps: { inputMode: "numeric" }},
  {name: 'transactionNumber', label: 'Invoice Number', value: '', numberField: true, inputProps: { inputMode: "numeric" }},
];

const filterNames = {ASSET_TYPE_GROUP: 'assetTypeGroup', TAX_STATUS: 'taxStatus'}

const filterBySelectOptions: {label: string, value: string, name: string, option: {label: string, value: string}[]}[] = [
  {
    label: 'Booking Charge Type', value: '', name: 'transactionType',
    option: [
      {label: 'All', value: ''},
      ...Object.keys(BookingTransactionType).map(key => ({label: BookingTransactionTypeLabel[key as keyof typeof BookingTransactionTypeLabel], value: key}))
    ]
  },
  {
    label: 'Booking Status', value: '', name: 'bookingStatus',
    option: [
      {label: 'All', value: ''},
      ...Object.keys(BookingStatus).map(key => ({label: BookingStatus[key as keyof typeof BookingStatus], value: key})),
    ]
  },
  {
    label: 'Transaction Status', value: '', name: 'supplierTransactionStatus',
    option: [
      {label: 'All', value: ''},
      ...Object.values(SupplierInvoiceStatusGroup),
    ],
  },
  {
    label: 'Payment Processor', value: '', name: 'paymentProcessor',
    option: [
      {label: 'All', value: ''},
      {label: PaymentProcessor.STRIPE.label, value: PaymentProcessor.STRIPE.value},
      {label: PaymentProcessor.DWOLLA.label, value: PaymentProcessor.DWOLLA.value},
    ]
  },
  {
    name: filterNames.ASSET_TYPE_GROUP,
    value: '',
    label: 'Asset Type',
    option: [{label: 'Truck Only', value: 'TRUCK_ONLY'}]
  },
  {
    name: filterNames.TAX_STATUS,
    value: '',
    label: 'Tax Status',
    option: [{label: 'Committed', value: 'COMMITTED'}]
  }
];

export {
  sortByOptions,
  filterByOptions,
  filterBySelectOptions,
  filterNames
};
